
import React from 'react';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import { isNLW, isANT, isFcpworks, isTranscoder1 } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';

import videoImage from 'Flow2/components/CustomCollections/CustomImages/video.png';
import pdfImage from 'Flow2/components/CustomCollections/CustomImages/pdfFile.png';
import fileImage from 'Flow2/components/CustomCollections/CustomImages/allFiles.png';
import textImage from 'Flow2/components/CustomCollections/CustomImages/document.png';
import audioImage from 'Flow2/components/CustomCollections/CustomImages/audio.png';
import arrowDownIcon from "Flow2/components/CustomCollections/CustomImages/arrowDown.png";
import arrowUpIcon from "Flow2/components/CustomCollections/CustomImages/arrowUp.png";
import plusIcon from 'Flow2/components/CustomCollections/CustomImages/plusIcon.png';
import minusIcon from 'Flow2/components/CustomCollections/CustomImages/minusIcon.png';
import deleteOn from "Flow2/components/CustomCollections/CustomImages/delete2.png";
import deleteOff from "Flow2/components/CustomCollections/CustomImages/deleteGrey.png";
import uploadIcon from "Flow2/components/CustomCollections/CustomImages/uploadWhite.png";
import cancelIcon from 'Flow2/components/CustomCollections/CustomImages/cancelRed.png';
import whitesearch from "Flow2/components/CustomCollections/CustomImages/whitesearch.png";
import epSearchIcon from 'Flow2/components/CustomCollections/CustomImages/search2.png';
import uploadGrayIcon from "Flow2/components/CustomCollections/CustomImages/upload_grey.png";
import DeleteButton from 'Flow2/components/CustomCollections/CustomImages/delete4.png';
import AddButton from 'Flow2/components/CustomCollections/CustomImages/addicon.png';
import descriptionIcon from "Flow2/components/CustomCollections/CustomImages/description.png";
import searchfileIcon from "Flow2/components/CustomCollections/CustomImages/searchfileWhite.png";
import clearAllIcon from "Flow2/components/CustomCollections/CustomImages/delete.png";
import calendarIcon from 'Flow2/components/CustomCollections/CustomImages/calendar.png';
import contactIcon from 'Flow2/components/CustomCollections/CustomImages/contact1.png';
import teamIcon from 'Flow2/components/CustomCollections/CustomImages/team1.png';
import companyIcon from 'Flow2/components/CustomCollections/CustomImages/company1.png';
import placeIcon from 'Flow2/components/CustomCollections/CustomImages/place1.png';
import agencyIcon from 'Flow2/components/CustomCollections/CustomImages/agency1.png';
import directorIcon from 'Flow2/components/CustomCollections/CustomImages/director1.png';
import protagonistIcon from 'Flow2/components/CustomCollections/CustomImages/protagonist1.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCut, faArrowUp, faTimes, faInfo, faCalendarTimes, faUser, faLaptop, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';


export const getIconsForData = (data) => {
    let icon = null;
    switch (data) {
        case CustomTypes.DATE:
            icon = faCalendarTimes;
            break;
        case CustomTypes.USER:
            icon = faUser;
            break;
        case CustomTypes.ACTION:
        case CustomTypes.TITLE:
            icon = faLaptop;
            break;
    }
    return icon;
}

export const getImageForApp = (name) => {
    switch (name) {
        case "videoImage":
            return videoImage;
        case "pdfImage":
            return pdfImage;
        case "fileImage":
            return fileImage;
        case "textImage":
            return textImage;
        case "audioImage":
            return audioImage;
        default:
            break;
    }
}

export const getFontIconForApp = (name) => {
    switch (name) {
        case "faCut":
            return <FontAwesomeIcon style={{ color: 'red', fontSize: '12px' }} icon={faCut} />;
        default:
            break;
    }
}

export const getFontAweIconForApp = (name) => {
    switch (name) {
        case "faCut":
            return faCut;
        case "faArrowUp":
            return faArrowUp;
        case "faTimes":
            return faTimes
        case "faInfo":
            return faInfo;
        case "faChevronDown":
            return faChevronDown;
        case "faChevronUp":
            return faChevronUp;
        default:
            break;
    }
}

export const getIconForApp = (name) => {
    switch (name) {
        case "plusIcon":
            return plusIcon;
        case "minusIcon":
            return minusIcon;
        case "deleteOn":
            return deleteOn;
        case "deleteOff":
            return deleteOff;
        case "uploadIcon":
            return uploadIcon;
        case "cancelIcon":
            return cancelIcon;
        case "whitesearch":
            return whitesearch;
        case "epSearchIcon":
            return epSearchIcon;
        case "uploadGrayIcon":
            return uploadGrayIcon;
        case "DeleteButton":
            return DeleteButton;
        case "AddButton":
            return AddButton;
        case "descriptionIcon":
            return descriptionIcon;
        case "searchfileIcon":
            return searchfileIcon
        case "clearAllIcon":
            return clearAllIcon;
        case "calendarIcon":
            return calendarIcon;
        case "contactIcon":
            return contactIcon;
        case "teamIcon":
            return teamIcon
        case "companyIcon":
            return companyIcon;
        case "placeIcon":
            return placeIcon
        case "agencyIcon":
            return agencyIcon
        case "directorIcon":
            return directorIcon
        case "protagonistIcon":
            return protagonistIcon;
        default:
            break;
    }
}

export const toggleArrowIcon = (display) => {
    let iconShow;
    if (display === 'none') iconShow = arrowDownIcon;
    else iconShow = arrowUpIcon;

    return iconShow;
}

export const getSubMenuIcon = (display) => {
    let iconShow;

    if (display === 'none') iconShow = getIconForApp("plusIcon");
    else iconShow = getIconForApp("minusIcon");

    return iconShow;
}


export const CustomDataThumbnail = (props) => {
    let classes = props.classes;
    if (props.fileType.startsWith("video/"))
        return <img className={classes.ThumbsContainer} src={videoImage} alt="Video Thumbnail" />
    else if (props.fileType.startsWith("image/"))
        return <img className={classes.ThumbsContainer} src={props.url} alt="Image Thumbnail" />
    else if (props.fileType.includes("application/pdf"))
        return <img className={classes.ThumbsContainer} src={pdfImage} alt="Pdf Thumbnail" />
    else if (props.fileType.includes("document") || props.fileType.includes("text"))
        return <img className={classes.ThumbsContainer} src={textImage} alt="Document Thumbnail" />
    else if (props.fileType.includes("audio"))
        return <img className={classes.ThumbsContainer} src={audioImage} alt="Audio Thumbnail" />
    else
        return <img className={classes.ThumbsContainer} src={fileImage} alt="File Thumbnail" />

}

const getAdditionalInfo = (file) => {
    let addInfo = null;
    if (isTranscoder1() || isANT() || isFcpworks()) {
        if (file && file.tags) {
            addInfo = file.tags.split(",").filter(item => item.toLowerCase().trim() === 'preview' || item.toLowerCase().trim() === "vimeo" || item.toLowerCase().trim() === "flowedge");
            if (addInfo.length > 0) return addInfo.map(item => DataUtil.writeName(item)).join(", ");
        }
    }
    return null;
}

export const getMfDataForApp = (file, info = null) => {
    switch (info) {
        case "additionalPurpose":
            return getAdditionalInfo(file);
        case "cut":
            if (file.tags && file.tags.includes('cut'))
                return getFontIconForApp("faCut");
            break;
        case "icon":
            return getFileTypeIconForApp(file);
        case "audioFormats":
            return CustomTypes.CUSTOM_AUDIO_TYPE.split(';');
        default:
            return false;
    }
}

export const getFileTypeIconForApp = (file) => {
    let fileExt = file.getFilename().split('.').pop().toLowerCase();
    let audioFormats = CustomTypes.CUSTOM_AUDIO_TYPE.split(';');

    if (CustomTypes.CUSTOM_VIDEO_TYPE.split(';').indexOf(fileExt) !== -1)
        return getImageForApp("videoImage");

    else if (fileExt === "pdf")
        return getImageForApp("pdfImage");

    else if (CustomTypes.CUSTOM_DOCUMENT_TYPE.split(';').indexOf(fileExt) !== -1)
        return getImageForApp("textImage");

    else if ((audioFormats.indexOf(fileExt) !== -1) && !isNLW())
        return getImageForApp("audioImage");

    return getImageForApp("fileImage");
}

